<template>
  <div>
    <slot></slot>
    <tooltip :content="tooltipContent()" />
  </div>
</template>

<script>
export default {
  name: "DriverLegend",
  data() {
    return {
      legend: [
        {
          type: "LINE",
          color: "GREEN",
          label: "Performance window THD < 20% and PF > 0.9",
        },
        { type: "DOTTED", color: "BLUE", label: "Min AOC level" },
        {
          type: "DOTTED",
          color: "ORANGE",
          label: "Min AOC level for min Dim level",
        },
        { type: "LINE", color: "BLUE", label: "Driver window" },
        { type: "LINE", color: "RED", label: "Tolerance range" },
        { type: "DOT", color: "RED", label: "Operating point" },
      ],
    };
  },
  methods: {
    firstHalfList(list) {
      if (list.length % 2 === 0) {
        return list.slice(0, list.length / 2);
      } else {
        return list.slice(0, list.length / 2 + 1);
      }
    },
    secondHalfList(list) {
      if (list.length % 2 === 0) {
        return list.slice(list.length / 2, list.length);
      } else {
        return list.slice(list.length / 2 + 1, list.length);
      }
    },
    getClasses(item) {
      let result = [];
      //Color classes
      switch (item.color) {
        case "RED":
          result.push("red");
          break;
        case "BLUE":
          result.push("blue");
          break;
        case "GREEN":
          result.push("green");
          break;
        case "ORANGE":
          result.push("orange");
          break;
        case "BLACK":
          result.push("black");
          break;
      }
      //Type classes
      switch (item.type) {
        case "LINE":
          result.push("line");
          break;
        case "DOT":
          result.push("dot");
          break;
        case "DOTTED":
          result.push("dotted");
          break;
      }
      return result;
    },
    tooltipContent() {
      let html = '<div class="legend"><ul>';

      for (let l of this.legend) {
        let color = l.color.toLowerCase();
        let type = l.type.toLowerCase();

        html += "<li>";
        html += '<span class="' + color + " " + type + '"></span>';
        html += '<div class="legend-label">' + l.label + "</div>";
        html += "</li>";
      }
      html += "</ul></div>";

      return html;
    },
  },
};
</script>

<style lang="scss">
.legend-padding {
  .easy-tooltip {
    position: absolute;
    right: 26px;
    top: 36px;
  }
}
</style>
